import { styled } from "@mui/material/styles";
import { Box, TextField, Select, MenuItem, Button } from "@mui/material";

export const FullContainer = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 20px",
    width: "100%",
}));

export const FilterBarContainer = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: "20px",
}));

export const LeftBlock = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
}));

export const RightBlock = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    gap: "16px",
}));

export const SearchContainer = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    border: `1px solid #000000ff`,
    borderRadius: "8px",
    padding: "4px 12px",
    width: "250px",
    marginRight: "8px",
}));

export const StyledTextField = styled(TextField)({
    width: "100%",
    "& input": {
        padding: "6px",
    },
});

export const StyledSelect = styled(Select)({
    width: "180px",
    height: "40px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    border: `1px solid #000000ff`,
    paddingLeft: "8px",
});

export const StyledMenuItem = styled(MenuItem)(() => ({
    fontSize: "14px",
}));

export const StyledButton = styled(Button)(() => ({
    backgroundColor: "#0018A8",
    color: "white",
    fontWeight: 600,
    borderRadius: "8px",
    height: "40px",
    width: "80px",
    textTransform: "uppercase",
    "&:hover": {
        backgroundColor: "#001080",
    },
}));
